var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevelopment = function SvgDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#development_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 11.39c0-2.352-1.02-5.72-3.099-6.73a.412.412 0 0 0-.567.238C11.8 6.326 11 9.618 11 9.618s-.805-3.317-1.332-4.72c-.087-.233-.346-.34-.554-.204C7.68 5.638 6 9.08 6 11.39c0 2.822 2.24 5.11 5 5.11h.02c2.752-.012 4.98-2.619 4.98-5.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.268V32.62h3V16.24c-.475.17-.975.258-1.48.26H11a4.9 4.9 0 0 1-1.5-.232m0 7.952v-7.952 3.42c-.584-.628-1.264-1.188-1.928-1.57-1.883-1.089-5.455-1.638-6.263-.239s1.337 4.15 3.337 5.305c1.374.793 3.436 1.27 4.854 1.035Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.243 15.487c3.088-.21 5.754-2.985 5.754-6.38 0-2.96-1.628-7.14-4.117-8.434a.397.397 0 0 0-.562.205c-.526 1.31-1.32 4.622-1.32 4.622s-.92-3.287-1.34-4.56a.407.407 0 0 0-.587-.243c-1.074.575-1.986 1.687-2.673 3.003 1.392 1.612 2.598 4.262 2.6 7.657 0 1.453-.256 2.606-.67 3.516q.557.293 1.172.453V32.5h3V21.85c1.467.557 4.121.03 5.807-.942 2.135-1.233 4.426-4.17 3.563-5.664-.862-1.493-4.676-.907-6.686.254-.965.557-1.96 1.462-2.684 2.425v-2.665q-.615.186-1.257.23z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "development_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h32v33H0z"
  })))));
};
export default SvgDevelopment;